/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useContext, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { SocialNetwork, Website } from './InfluencerContext';
import LoadingIcon from '../../icons/LoadingIcon';
// import useNavigation from '../../hooks/useNavigation';
import useUserDetails from '../../hooks/useUserDetails';
import { useAppSelector } from '../../store/store';
import { SocialNetworks } from './SignupContext';

export interface Artist {
  id: string;
  fullName: string;
  about: string;
  categories: Array<string>;
  socialNetworks: Array<SocialNetwork>;
  website: Website;
  headshot: string;
  coverphoto: string;
}

const initialArtist: Artist = {
  id: '',
  fullName: '',
  about: '',
  categories: [],
  socialNetworks: [],
  website: { url: '' },
  headshot: '',
  coverphoto: ''
};

interface ArtistContextProps {
  artist: Artist;
  setArtist: React.Dispatch<React.SetStateAction<Artist>>;
}

const ArtistContext = createContext<ArtistContextProps | undefined>(undefined);

export const ArtistProvider: React.FC = () => {
  const { profile, isLoading: profileLoading } = useAppSelector(e => e.profile);
  const [artist, setArtist] = useState<Artist>(initialArtist);
  const [loading, setLoading] = useState<boolean>(true);
  const { user, isLoading } = useUserDetails();
  // const navigation = useNavigation();

  console.log(profileLoading);
  console.log(user);
  useEffect(() => {
    if (profile?.artist) {
      const socialNetworks: SocialNetworks | undefined = profile.artist.socialNetworks;
      // Use bracket notation to safely access optional properties
      const xData = socialNetworks?.['x'];
      const twitterData = socialNetworks?.['twitter'];
      
      const socialMedia: Array<SocialNetwork> = [
        {
          name: 'instagram',
          followers: socialNetworks?.instagram?.followers ?? 0,
          handleName: socialNetworks?.instagram?.handle ?? ''
        },
        {
          name: 'facebook',
          followers: socialNetworks?.facebook?.followers ?? 0,
          handleName: socialNetworks?.facebook?.handle ?? ''
        },
        {
          name: 'x',
          followers: xData?.followers ?? twitterData?.followers ?? 0,
          handleName: xData?.handle ?? twitterData?.handle ?? ''
        },
        {
          name: 'tiktok',
          followers: socialNetworks?.tiktok?.followers ?? 0,
          handleName: socialNetworks?.tiktok?.handle ?? ''
        }
      ];

      setArtist({
        id: profile.artist.id || '',
        fullName: profile.artist.fullName || '',
        about: profile.artist.about || '',
        categories: profile.artist.categories || [],
        socialNetworks: socialMedia,
        website: typeof profile.artist.website === 'string' 
          ? { url: profile.artist.website } 
          : (profile.artist.website || { url: '' }),
        headshot: profile.artist.headshot || '',
        coverphoto: profile.artist.coverphoto || ''
      });
    }
    setLoading(false);
  }, [profile?.artist]);



  if (loading || isLoading) {
    return (
      <div className="grid place-items-center h-screen w-full">
        <div>
          <LoadingIcon />
          <p className="font-inter text-semibold mt-4">Authenticating...</p>
        </div>
      </div>
    );
  }

  // if (navigation) return navigation;

  return (
    <ArtistContext.Provider value={{ artist, setArtist }}>
      <Outlet />
    </ArtistContext.Provider>
  );
};

export const useArtist = (): ArtistContextProps => {
  const context = useContext(ArtistContext);
  if (!context) {
    throw new Error('useArtist must be used within an ArtistProvider');
  }
  return context;
};
